import {
    type OpenApiGetDiscountsSearchParams,
    type OpenApiPromocodeListSearchParams,
    type OpenApiSchemaDiscountKind,
} from '#shared/api/schema';

const byDefault = 'created_at';

const sortByMap: Record<
    Required<OpenApiPromocodeListSearchParams>['sort_by'],
    OpenApiGetDiscountsSearchParams['sort_by'] | undefined
> = {
    status: 'status',
    created_at: 'created_at',
    usage_count: byDefault,
    code: 'title',
    type: byDefault,
    title: 'title',
};

export function mapPromocodesReqToDiscountsReq(
    request: OpenApiPromocodeListSearchParams,
    kind: OpenApiSchemaDiscountKind
): OpenApiGetDiscountsSearchParams {
    return {
        kind,
        is_active: request?.status ? request.status === 'active' : undefined,
        sort_order: request?.sort_direction,
        sort_by: request?.sort_by ? sortByMap[request?.sort_by] : byDefault,
        page: request?.page ?? 1,
        per_page: request?.per_page ?? 25,
    };
}
